// config.ts
import { Config } from "@adornis/config/config.js";
var whatsappConfig = new Config("whatsapp-config", {
  appId: {
    client: false,
    env: true,
    name: "WHATSAPP_APP_ID",
    required: true
  },
  appSecret: {
    client: false,
    env: true,
    name: "WHATSAPP_APP_SECRET",
    required: true
  },
  businessId: {
    client: false,
    defaultVal: "",
    env: true,
    name: "WHATSAPP_BUSINESS_ID",
    required: false
  },
  version: {
    client: false,
    defaultVal: "v20.0",
    env: true,
    name: "WHATSAPP_VERSION",
    required: false
  },
  phoneNumberId: {
    client: false,
    defaultVal: "",
    env: true,
    name: "WHATSAPP_PHONE_NUMBER_ID",
    required: false
  },
  accessToken: {
    client: false,
    env: true,
    name: "WHATSAPP_ACCESS_TOKEN",
    required: true
  },
  webhookVerifyToken: {
    client: false,
    defaultVal: "",
    env: true,
    name: "WHATSAPP_WEBHOOK_VERIFY_TOKEN",
    required: false
  }
});
export {
  whatsappConfig
};
